export default __webpack_public_path__ + "static/media/melody.020edf53.jpg";